// extracted by mini-css-extract-plugin
module.exports = {"main":"CollapsableSubBar_main__VZPCl"};